(function () {

    // Load YouTube Iframe API once
    let ytReady = false, ytLoading = false, ytWaiters = [];
    function loadYT(cb){
        if (ytReady) return cb();
        ytWaiters.push(cb);
        if (ytLoading) return;
        ytLoading = true;
        const s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(s);
        window.onYouTubeIframeAPIReady = () => {
            ytReady = true; ytWaiters.forEach(f=>f()); ytWaiters = [];
        };
    }

    // Extract YouTube ID from URL or <iframe>
    function getYouTubeId(input){
        if (!input) return null;
        if (/<iframe/i.test(input)) {
            const m = input.match(/src=["']([^"']+)/i);
            if (m) input = m[1];
        }
        const m = input.match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{6,})/);
        return m ? m[1] : null;
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.VideoPlayer--full-stretched').forEach(root => {
            const type      = (root.dataset.type || '').toLowerCase();
            const src       = root.dataset.src || '';
            const posterURL = root.dataset.poster || '';
            const iconURL   = root.dataset.playIcon || '';

            // Ensure stage exists
            let stage = root.querySelector('.VideoPlayer__stage');
            if (!stage) { stage = document.createElement('div'); stage.className = 'VideoPlayer__stage'; root.prepend(stage); }

            // Ensure poster exists (always keep it in DOM; we just fade it once)
            let posterEl = stage.querySelector('.VideoPlayer__poster');
            if (!posterEl) { posterEl = document.createElement('img'); posterEl.className = 'VideoPlayer__poster'; stage.appendChild(posterEl); }
            if (posterURL) posterEl.src = posterURL;

            // Ensure overlay button + icon exist
            let overlayBtn = root.querySelector('.VideoPlayer__overlayPlay');
            if (!overlayBtn) { overlayBtn = document.createElement('button'); overlayBtn.className = 'VideoPlayer__overlayPlay'; overlayBtn.type='button'; root.appendChild(overlayBtn); }
            let iconEl = overlayBtn.querySelector('.VideoPlayer__playIcon');
            if (!iconEl) { iconEl = document.createElement('img'); iconEl.className = 'VideoPlayer__playIcon'; overlayBtn.appendChild(iconEl); }
            if (iconURL) iconEl.src = iconURL;

            // Utility: clean previous backend without touching poster
            function clearBackend(){
                stage.querySelectorAll('video, iframe, .VideoPlayer__holder').forEach(el => el.remove());
            }

            // Local file backend
            function bootLocal(){
                clearBackend();
                const v = document.createElement('video');
                v.src = src;
                v.playsInline = true;
                v.controls = false;        // we drive UI
                v.preload = 'metadata';
                // Note: we keep posterEl separate so v.poster is optional
                stage.appendChild(v);

                // UX: overlay click = play/pause
                overlayBtn.addEventListener('click', () => {
                    if (!root.classList.contains('is-started')) root.classList.add('is-started'); // one-time hide poster
                    if (v.paused) v.play().catch(()=>{}); else v.pause();
                });

                // Click on container toggles too (except buttons/links)
                root.addEventListener('click', (e) => {
                    if (e.target.closest('button,a')) return;
                    if (!root.classList.contains('is-started')) root.classList.add('is-started');
                    if (v.paused) v.play().catch(()=>{}); else v.pause();
                });

                v.addEventListener('play',  () => root.classList.add('is-playing'));
                v.addEventListener('pause', () => root.classList.remove('is-playing'));
                v.addEventListener('ended', () => root.classList.remove('is-playing'));
            }

            // YouTube backend
            function bootYouTube(){
                const id = getYouTubeId(src);
                if (!id) { console.warn('[VideoPlayer] Invalid YouTube source:', src); return; }

                loadYT(() => {
                    clearBackend();
                    const holder = document.createElement('div');
                    holder.className = 'VideoPlayer__holder';
                    holder.style.cssText = 'position:absolute;inset:0;';
                    stage.appendChild(holder);

                    const player = new YT.Player(holder, {
                        videoId: id,
                        playerVars: { controls: 0, rel: 0, modestbranding: 1, playsinline: 1 },
                        events: {
                            onStateChange: (e) => {
                                const P = YT.PlayerState;
                                if (e.data === P.PLAYING) {
                                    root.classList.add('is-started');  // one-time poster hide
                                    root.classList.add('is-playing');  // hide overlay while actually playing
                                } else if (e.data === P.PAUSED) {
                                    root.classList.remove('is-playing'); // show overlay again on pause
                                } else if (e.data === P.ENDED || e.data === P.UNSTARTED || e.data === P.BUFFERING) {
                                    root.classList.remove('is-playing');
                                }
                            }
                        }
                    });

                    // Overlay click toggles playback
                    overlayBtn.addEventListener('click', () => {
                        const P = YT.PlayerState;
                        const s = player.getPlayerState?.();
                        if (!root.classList.contains('is-started')) root.classList.add('is-started');
                        (s === P.PLAYING) ? player.pauseVideo() : player.playVideo();
                    });

                    // Click on container toggles too (except buttons/links)
                    root.addEventListener('click', (e) => {
                        if (e.target.closest('button,a')) return;
                        const P = YT.PlayerState;
                        const s = player.getPlayerState?.();
                        if (!root.classList.contains('is-started')) root.classList.add('is-started');
                        (s === P.PLAYING) ? player.pauseVideo() : player.playVideo();
                    });
                });
            }

            if (type === 'file') bootLocal();
            else if (type === 'youtube') bootYouTube();
        });
    });
})();